<p>generic-table-body-renderer works!</p>
